// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("bs-platform/lib/js/curry.js");
var Infix$BsBastet = require("./Infix.bs.js");
var Function$BsBastet = require("./Function.bs.js");

var id = Function$BsBastet.Category.id;

var $less$dot = Function$BsBastet.Infix.$less$dot;

function append(f, g) {
  return /* Endo */{
          _0: Curry._2($less$dot, f._0, g._0)
        };
}

var Magma = {
  append: append
};

var Semigroup = {
  append: append
};

var empty = /* Endo */{
  _0: id
};

var Monoid = {
  append: append,
  empty: empty
};

var include = Infix$BsBastet.Magma_Any(Magma);

var Infix = include;

exports.id = id;
exports.$less$dot = $less$dot;
exports.Magma = Magma;
exports.Semigroup = Semigroup;
exports.Monoid = Monoid;
exports.Infix = Infix;
/* include Not a pure module */
